import moment from 'moment';

import db from './db.json';

export const getHeader = () => {
	return db.header;
};

export const getHome = () => {
	return db.home;
};

export const getAbout = () => {
	return {
		...db.about, ...{
			params: {
				age: moment().diff('1989-01-06', 'years', false),

			}
		},
		...{socials: {socials: db.about.socials, only: ['linkedin', 'skype', 'whatsapp', 'email']}}
	};
};

export const getServices = () => {
	return db.services;
};

export const getResume = () => {
	return db.resume;
};

export const getSkill = () => {
	return db.skill;
};

export const getPortfolio = () => {
	return db.portfolio;
};

export const getFooter = () => {
	return {...db.footer, ...{socials: {socials: db.about.socials, only: ['facebook', 'twitter', 'instagram', 'medium', 'github', 'gitlab']}}};
};

export const getFunfacts = () => {
	return db.funfacts;
};

export default {
	getHeader,
	getHome,
	getAbout,
	getServices,
	getResume,
	getSkill,
	getPortfolio,
	getFooter,
	getFunfacts
}



// WEBPACK FOOTER //
// ./src/api/index.js